<template>
  <page>
    <div slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <template v-slot:activator="{ on }">
            <v-btn text color="secondary" v-on="on">
              Related Tasks
              <v-icon right>mdi-link</v-icon>
            </v-btn>
          </template>
          <side-function-menu :items="sideFunction" @doClick="$router.push($event)"></side-function-menu>
        </v-menu>
      </div>
    </div>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl6 lg6 xs6>
                        <v-text-field
                          v-model="filters.inter"
                          :label="filtersLabel.inter"
                          :error-messages="errors.collect('inter')"
                          data-vv-name="inter"
                          :data-vv-as="filtersLabel.inter"
                          v-validate="'entry|max:8'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl6 lg6 xs6>
                        <v-text-field
                          v-model="filters.intermediaryName"
                          :label="filtersLabel.intermediaryName"
                          :error-messages="errors.collect('intermediaryName')"
                          data-vv-name="intermediaryName"
                          :data-vv-as="filtersLabel.intermediaryName"
                          v-validate="'name|max:200'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl6 lg6 xs6>
                        <v-autocomplete
                          :items="interGroupList"
                          v-model="filters.interGroupList"
                          :label="filtersLabel.interGroupList"
                          item-text="label"
                          item-value="value"
                          data-vv-name="interGroupList"
                          :data-vv-as="filtersLabel.interGroupList"
                          :error-messages="errors.collect('interGroupList')"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xl6 lg6 xs6>
                        <v-autocomplete
                          :items="statusList"
                          v-model="filters.suspended"
                          column
                          :label="filtersLabel.suspended"
                          item-text="label"
                          item-value="value"
                          :error-messages="errors.collect('suspended')"
                          data-vv-name="suspended"
                          :data-vv-as="filtersLabel.suspended"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xl6 lg6 xs12>
                        <cal-picker
                          :label="filtersLabel.dateOpened"
                          v-model="filters.dateOpened"
                          :error-messages="errors.collect('dateOpened')"
                          data-vv-name="dateOpened"
                          :data-vv-as="filtersLabel.dateOpened"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <message :messages="messages"></message>
    </v-flex>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="doNew">
            New Intermediary
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <v-data-table
          v-bind:headers="headers"
          v-bind:items="items"
          :server-items-length="totalItems"
          :footer-props="{ 'items-per-page-options': itemsPerPage }"
          v-bind:options.sync="pagination"
          item-key="inter"
          :loading="loading"
          :no-data-text="noDataText"
        >
          <template v-slot:item="row">
            <tr>
              <td>{{ row.item.inter }}</td>
              <td class="text-xs-left">{{ row.item.intermediaryName }}</td>
              <td class="text-xs-left">{{ row.item.interGroupName }}</td>
              <td class="text-xs-left">{{ formatDate(row.item.dateOpened) }}</td>
              <td class="text-xs-left">{{ formatDate(row.item.dateClosed) }}</td>
              <td class="text-xs-left">{{ formatBoolean(row.item.suspended) }}</td>
              <td class="table-action-header">
                <table-action
                  :rowData="row"
                  query
                  :review="checkAccess([permissionKeys.perm_050205])"
                  @review="doReview"
                  @query="doQuery"
                  remove
                  @remove="doPromptRemove(row.item)"
                ></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
      <confirm v-model="promptRemove" @ok="doRemove"> Are you sure that you want to delete the selected Intermediary? ({{ deleteInter }}) </confirm>
    </v-flex>
  </page>
</template>

<script>
import clone from 'clone'
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { ADMININTERMEDIARY_INTERGROUPLIST } from '@/store/types'
import { removeTime, formatDisplayDateTime2, formatDisplayDate } from '@/utils/date'
import { permissionKeys } from '@/mixins/global/permissionKey'
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'

export default {
  data() {
    return {
      sideFunction: [
        {
          text: 'Executive In Charge',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'execInCharge' }
        },
        {
          text: 'Intermediary Type',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'interType' }
        },
        {
          text: 'Permit Scheme',
          icon: 'mdi-tune',
          iconColor: 'primary',
          params: { name: 'interScheme' }
        }
      ],
      toogleArray: [false],
      headers: [
        { text: 'Intermediary Reference', align: 'left', value: 'interId' },
        { text: 'Intermediary Name', align: 'left', value: 'intermediaryName' },
        { text: 'Intermediary Group', align: 'left', value: 'interGroup' },
        { text: 'Date Opened', align: 'left', value: 'dateOpened' },
        { text: 'Date Closed', align: 'left', value: 'dateClosed' },
        { text: 'Suspended', align: 'left', value: 'suspended' },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      filters: {
        inter: null,
        intermediaryName: null,
        suspended: null,
        interGroupCode: null,
        interGroupName: null,
        dateOpened: null,
        interGroupList: null
      },
      filtersLabel: {
        inter: 'Intermediary Reference',
        intermediaryName: 'Intermediary Name',
        suspended: 'Status',
        interGroupList: 'Intermediary Group',
        dateOpened: 'Date Opened'
      },
      statusList: [
        { label: 'All', value: null },
        { label: 'Not Suspended', value: false },
        { label: 'Suspended', value: true }
      ],
      promptRemove: false,
      selectedInter: undefined,
      deleteInter: '',
      permissionKeys: permissionKeys,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  computed: {
    ...mapGetters(['checkAccess']),
    interGroupList() {
      return this.$store.state.adminInter.interGroupList
    },
    adminInterInit() {
      return this.$store.state.adminInter
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    pagination: function (value) {
      if (this.adminInterInit.init === 1) {
        this.fetchData(false)
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('interManagementInit')])
      if (this.adminInterInit.init === 1) {
        this.fetchData(true)
        Promise.all([this.getInterGroupList()])
      }
    },
    async fetchData(options) {
      const apiUrl = this.$store.state.adminInter.menu.IntermediariesList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.dateOpened) {
            massageFilters.dateOpened = formatDisplayDateTime2(removeTime(massageFilters.dateOpened))
          }

          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((intermediary) => {
                const convertInter = {
                  interNoAe: intermediary.interNoAe,
                  inter: intermediary.inter,
                  intermediaryName: intermediary.name,
                  suspended: intermediary.suspended,
                  inactive: intermediary.inactive,
                  perDebtTran: intermediary.perDebtTran,
                  interGroupCode: intermediary.interGroupCode,
                  interGroupName: intermediary.interGroupName,
                  officeNo: intermediary.officeNo,
                  faxNo: intermediary.faxNo,
                  dateOpened: intermediary.dateOpened,
                  dateClosed: intermediary.dateClosed
                }
                this.items.push(convertInter)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.filters.inter = null
      this.filters.intermediaryName = null
      this.filters.suspended = null
      this.filters.dateOpened = null
      this.filters.dateClosed = null
      this.filters.interGroupList = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doQuery(data) {
      if (data && data.item && data.item.inter) {
        this.$router.push({
          name: 'queryProfile',
          params: { inter: data.item.inter, interGroupCode: data.item.interGroupCode, interNoAe: data.item.interNoAe }
        })
      }
    },
    doReview(data) {
      if (data && data.item && data.item.inter) {
        this.$router.push({
          name: 'reviewProfile',
          params: { inter: data.item.inter, interGroupCode: data.item.interGroupCode, interNoAe: data.item.interNoAe }
        })
      }
    },
    doNew() {
      if (this.checkAccess([this.permissionKeys.perm_050205])) {
        this.$router.push({ name: 'reviewProfile', params: { inter: 'new', interGroupCode: 'new' } })
      } else {
        this.$toast.warning('You do not have access to this resource')
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedInter = data
        this.deleteInter = data.inter
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.adminInter.menu.interDelete
      if (apiURI) {
        const expand = this.selectedInter
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.fetchData(true)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatDateTime2(dateTime) {
      return formatDisplayDateTime2(dateTime)
    },
    async getInterGroupList() {
      const apiURI = this.$store.state.adminInter.menu.interGroup
      try {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.$store.commit(ADMININTERMEDIARY_INTERGROUPLIST, data.data.interGroupList)
        }
      } catch (err) {
        throw err
      }
    }
  },
  mounted() {
    this.doInit()
  },
  components: {
    SideFunctionMenu
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style lang="scss">
</style>
